// import calcMatchScore from "../MatchScore/calcMatchScore";
import cloneDeep from "lodash/cloneDeep";

const Private = {
  priceSort: function(chargers, direction) {
    return chargers.sort((a, b) => {
      let price = charger => charger.price;
      switch (direction) {
        case "asc":
          return price(a) - price(b);
        case "desc":
          return price(b) - price(a);
        default:
          return chargers;
      }
    });
  },
  cordLengthSort: function(chargers, direction) {
    return chargers.sort((a, b) => {
      let range = charger => charger.cord_length;
      switch (direction) {
        case "asc":
          return range(a) - range(b);
        case "desc":
          return range(b) - range(a);
        default:
          return chargers;
      }
    });
  }
};

const sortChargers = (
  chargers,
  sortType,
  sortDirection,
) => {
  const clonedChargers = cloneDeep(chargers);

  switch (sortType) {
    case "price":
      return Private.priceSort(clonedChargers, sortDirection);
    case "cord_length":
      return Private.cordLengthSort(clonedChargers, sortDirection);
    default:
      return Private.priceSort(clonedChargers, sortDirection);
  }
};

export default sortChargers;
